import Swal, { SweetAlertOptions, SweetAlertResult } from "sweetalert2";

/**
 * Fire a SweetAlert2 popup with dark mode support.
 * @param options SweetAlert2 options
 * @param darkMode Boolean indicating if dark mode is active
 * @returns Promise<SweetAlertResult>
 */
export const fireAlert = (options: SweetAlertOptions, darkMode: boolean): Promise<SweetAlertResult> => {
    const defaultOptions: SweetAlertOptions = {
        background: darkMode ? "#1a2035" : "#ffffff",
        color: darkMode ? "#ffffff" : "#000000",
        confirmButtonColor: options.confirmButtonColor || (darkMode ? "#344767" : "#1A73E8"),
        cancelButtonColor: options.cancelButtonColor || (darkMode ? "#d63031" : "#d33"),
    };

    return Swal.fire({
        ...defaultOptions,
        ...options,
    } as SweetAlertOptions);
};

export default fireAlert;
